<app-header-style-seven></app-header-style-seven>

<div class="department-page">
  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Annual Sports Report</span>
          <h1>{{ institutionName }}</h1>
          <p>
            {{ campusLine }}<br />
            {{ departmentName }}
          </p>
          <p>
            This report presents the major sports activities, intramural tournaments,
            staff events, student achievements, and special cricket tournaments
            organized during the academic year {{ academicYear }}.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Academic Year</span>
            <strong>{{ academicYear }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">ICCL Participation</span>
            <strong>{{ icclDepartments }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Intramural Participation</span>
            <strong>{{ intramuralDepartments }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Athletics Participation</span>
            <strong>{{ athleticsParticipation }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Sports update">
      <div class="notice-label">Sports Update</div>
      <div class="notice-track">
        <span>{{ sportsNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Report Menu</span>
          <h2>Sports Report</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Department Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Physical Education, Fatima Michael College of Engineering
            and Technology, Madurai - 20.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- Overview -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img [src]="overviewImage" alt="Sports Report Overview" />
              </div>

              <div class="section-copy">
                <h3>Sports Report Overview</h3>
                <p *ngFor="let paragraph of reportOverviewParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let stat of reportStats">
                <span class="fact-title">{{ stat.title }}</span>
                <p>{{ stat.value }}</p>
              </article>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Highlights of the Academic Year</h3>
                <p>
                  Key achievements and major sporting engagements organized during
                  the academic year.
                </p>
              </div>

              <ul class="feature-list">
                <li *ngFor="let item of reportHighlights">{{ item }}</li>
              </ul>
            </section>
          </ng-container>

          <!-- Major Events -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="content-card">
              <div class="section-head">
                <h3>Major Events</h3>
                <p>
                  Flagship sports programmes conducted during the academic year.
                </p>
              </div>

              <div class="lab-grid">
                <article class="lab-card report-event-card" *ngFor="let event of majorEvents">
                  <div class="lab-media">
                    <img [src]="event.image" [alt]="event.title" />
                  </div>

                  <div class="lab-body">
                    <span class="report-badge">{{ event.date }}</span>
                    <h4>{{ event.title }}</h4>
                    <p>{{ event.description }}</p>

                    <div class="highlight-box" *ngIf="event.highlight">
                      {{ event.highlight }}
                    </div>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Intramural Sports -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Intramural Sports</h3>
                <p>
                  Department-wise tournament highlights, participation details, and results.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Event</th>
                      <th>Dates</th>
                      <th>Participation</th>
                      <th>Winner</th>
                      <th>Runner-up</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of intramuralEvents">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.dates }}</td>
                      <td>{{ item.participants }}</td>
                      <td>{{ item.winner }}</td>
                      <td>{{ item.runnerUp }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Tournament Highlights</h3>
                <p>
                  Snapshots of intramural events conducted across different sports categories.
                </p>
              </div>

              <div class="lab-grid">
                <article class="lab-card report-event-card" *ngFor="let item of intramuralEvents">
                  <div class="lab-media">
                    <img [src]="item.image" [alt]="item.title" />
                  </div>

                  <div class="lab-body">
                    <span class="report-badge">{{ item.category }}</span>
                    <h4>{{ item.title }}</h4>

                    <ul class="report-meta-list">
                      <li><strong>Dates:</strong> {{ item.dates }}</li>
                      <li><strong>Participation:</strong> {{ item.participants }}</li>
                      <li><strong>Winner:</strong> {{ item.winner }}</li>
                      <li><strong>Runner-up:</strong> {{ item.runnerUp }}</li>
                    </ul>

                    <p>{{ item.description }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Staff Events -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Staff Events</h3>
                <p>
                  Sports participation and recreational events conducted for faculty and staff members.
                </p>
              </div>

              <div class="lab-grid">
                <article class="lab-card report-event-card" *ngFor="let event of staffEvents">
                  <div class="lab-media">
                    <img [src]="event.image" [alt]="event.title" />
                  </div>

                  <div class="lab-body">
                    <span class="report-badge">{{ event.date }}</span>
                    <h4>{{ event.title }}</h4>
                    <p>{{ event.description }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Student Achievements -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Student Achievements</h3>
                <p>
                  Outstanding individual sports performances by students of the institution.
                </p>
              </div>

              <div class="lab-grid achievements-grid">
                <article class="lab-card" *ngFor="let achievement of studentAchievements">
                  <div class="lab-image-wrap">
                    <img
                      [src]="achievement.image"
                      [alt]="achievement.studentName"
                      class="lab-image"
                    />
                  </div>

                  <div class="lab-content">
                    <h4>{{ achievement.studentName }}</h4>

                    <ul class="report-meta-list">
                      <li><strong>Department:</strong> {{ achievement.department }}</li>
                      <li><strong>Year:</strong> {{ achievement.year }}</li>
                      <li><strong>Event:</strong> {{ achievement.event }}</li>
                      <li><strong>Achievement:</strong> {{ achievement.achievement }}</li>
                    </ul>

                    <p>{{ achievement.description }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Lions Cricket League -->
          <ng-container *ngSwitchCase="'tab6'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  [src]="lionsCricketLeague.image"
                  [alt]="lionsCricketLeague.title"
                />
              </div>

              <div class="section-copy">
                <span class="report-badge">{{ lionsCricketLeague.date }}</span>
                <h3>{{ lionsCricketLeague.title }}</h3>
                <p>{{ lionsCricketLeague.description }}</p>

                <div class="highlight-box">
                  {{ lionsCricketLeague.highlight }}
                </div>
              </div>
            </section>
          </ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Department of Physical Education,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai - 20.
        </p>
        <span class="text-link">Academic Year: {{ academicYear }}</span>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Sports Culture</span>
        <h3>Building Team Spirit and Competitive Excellence</h3>
        <p>
          The Department of Physical Education continues to create opportunities
          for students and staff to participate, compete, excel, and represent
          the institution with pride.
        </p>
        <a class="apply-button" routerLink="/inquiry">Enquire Now</a>
      </article>
    </section>
  </div>
</div>